import { Fragment, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setShowTemplateSlideToTrue, setTemplate } from "../../../store/CatalogSlice";
import TemplateSlider from "../Sliders/TemplateSlider";
import CustomSelect from "../../CommonComponents/CustomSelect";
import CustomToolTip from "../../CommonComponents/CustomToolTip";
import { MissionStore } from "../../../store/MissionSlice";
import { showToastMessage } from "../../../utils/commonFunctions";
import { handleExportTemplate } from "../utils";

interface BusProps {
  templateList: any[];
  usedTemplates: string[];
  setDeleteCatalouge: (catalogue: any) => void;
  onEdit: (template: any, templateId: string) => void;
  onClone: (template: any, templateId: string) => void;
  onUpdate: (action?: string, templateId?: string) => void;
}

const Bus = ({ onUpdate, templateList, usedTemplates, setDeleteCatalouge, onEdit, onClone }: BusProps) => {

  const userData = useSelector((state: { mission: MissionStore }) => state.mission.userData);

  const dispatch = useDispatch();
  const [matchTemplate, setmatchTemplate] = useState<any[]>([]);
  const [vendorOptions, setvendorOptions] = useState<{ value: string; label: string }[]>([
    { value: 'Generic', label: 'Generic' },
    { value: 'XDLINX', label: 'XDLINX' },
  ]);
  const [vendorOptionsClear, setvendorOptionsClear] = useState<{ value: string; label: string } | null>(null);

  const [selectedVendor, setSelectedVendor] = useState<string | null>(null)

  const isTemplateSelected = useSelector((state: any) => state.catalog.isTemplateSelected);
  const [importExportLoader, setImportExportLoader] = useState<boolean>(false);


  const getMatchFromTemplateList = (temp) => {
    const uniqueVendors = Array.from(new Set(temp?.map(item => item.vendor)));
    if (selectedVendor) {
      setmatchTemplate([...temp]?.reverse()?.filter(item => item.vendor === selectedVendor));
    } else {
      setmatchTemplate([...temp].reverse());
    }
    setvendorOptions(
      uniqueVendors?.filter(vendor => vendor && String(vendor).trim() !== "").map(vendor => ({
        value: String(vendor),
        label: String(vendor),
      }))
    );
    if (importExportLoader) {
      setImportExportLoader(false)
    }
  };

  useEffect(() => {
    if (templateList?.length > 0) {
      getMatchFromTemplateList(templateList);
    }
  }, [templateList, selectedVendor])

  const handleVendorChange = (selectedOption) => {
    setSelectedVendor(selectedOption?.value);
    setvendorOptionsClear(selectedOption)
  };

  const reset_filter = () => {
    setSelectedVendor(null);
    setvendorOptionsClear(null)
  };

  const hasAccess = (uniqueId: string) => {
    if (usedTemplates.includes(uniqueId)) {
      showToastMessage('error', 'Template is already used in a Satellite. Cannot be edited.');
      return false;
    } else {
      return true;
    }
  };

  return (
    <Fragment>
      {isTemplateSelected && <TemplateSlider />}
      <div className="d-flex w-100 flex-1">
        <div className="w-20 bg-transparent border-right px-2 py-3 d-flex flex-column justify-content-between" >
          <div className=" d-flex flex-column gap-2">
            <span className="mt-2">Vendors</span>
            <CustomSelect
              options={vendorOptions}
              placeholder="Select Vendor"
              onChange={handleVendorChange}
              value={vendorOptionsClear}
              aria-label="vendor list"
            />
          </div>
          <div className="d-flex justify-content-center">
            <button className='btn btn-outline-primary px-8  fs-18' onClick={reset_filter}>Reset</button>
          </div>
        </div>
        <div className="w-80 d-flex flex-column flex-1 pop-scroll-3xl py-5 ps-3 gap-4">
          <div className="catalog__cards__grid__container">
            {matchTemplate?.length > 0 && matchTemplate.map((data) => {
              if (data["name"] === "Blank") return null;
              return (
                <div className="catalog__card__container" key={data?.["uniqueId"]}>
                  <div className="catalog__card__header">
                    <div className="d-flex flex-column">
                      <span className="card__text__container card__header_title">
                        <CustomToolTip title={data?.["name"]}>
                          {data?.["name"]}
                        </CustomToolTip>
                      </span>
                      <span className="card__text__container">{data?.['catalogue-type']}</span>
                    </div>
                    <div className="card__icon__container">
                      <Dropdown drop='end'>
                        <Dropdown.Toggle variant="transparent text-white fs-20">
                          <i className="fe fe-more-vertical"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            eventKey="0"
                            onClick={() => {
                              dispatch(setTemplate(data))
                              dispatch(setShowTemplateSlideToTrue());
                            }}
                          >
                            Summary
                          </Dropdown.Item>
                          {userData?.['feature-allowed']?.['Catalogue'] === 'Yes' &&
                            <Dropdown.Item
                              eventKey="1"
                              onClick={() => {
                                handleExportTemplate(data, `${data?.['name']}-template.json`);
                              }}
                            >
                              Export
                            </Dropdown.Item>
                          }
                          {data?.['owner-org'] === userData?.['owner_org'] &&
                            <Dropdown.Item
                              eventKey="2"
                              onClick={() => {
                                onUpdate("bus_update", data?.['uniqueId']);
                              }}
                            >
                              Update
                            </Dropdown.Item>
                          }
                          {data?.['owner-org'] === userData?.['owner_org'] &&
                            <Dropdown.Item
                              eventKey="3"
                              onClick={() => {
                                if (hasAccess(data?.['uniqueId'])) {
                                  onEdit(data, data?.['uniqueId']);
                                }
                              }}
                            >
                              Edit
                            </Dropdown.Item>
                          }
                          {data?.['owner-org'] === userData?.['owner_org'] &&
                            <Dropdown.Item
                              eventKey="4"
                              onClick={() => {
                                onClone(data, data?.['uniqueId']);
                              }}
                            >
                              Clone
                            </Dropdown.Item>
                          }
                          {data?.['owner-org'] === userData?.['owner_org'] &&
                            <Dropdown.Item
                              eventKey="5"
                              onClick={() => {
                                if (hasAccess(data?.['uniqueId'])) {
                                  setDeleteCatalouge(data);
                                }
                              }}
                            >
                              Delete
                            </Dropdown.Item>
                          }
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                  <div className="catalog__card__body">
                    <div className="card__body__text__container">
                      <span className="card__text__container card__body_title">
                        <CustomToolTip title={data?.["template-attribute"]?.["bus-type"]}>
                          {data?.["template-attribute"]?.["bus-type"]}
                        </CustomToolTip>
                      </span>
                      <span className="card__text__container card__body__subtitle">Bus Type</span>
                    </div>
                    <div className="card__body__text__container">
                      <span className="card__text__container card__body_title">
                        <CustomToolTip title={data?.["template-attribute"]?.["maxWeightInKg"]}>
                          {data?.["template-attribute"]?.["maxWeightInKg"]} Kg
                        </CustomToolTip>
                      </span>
                      <span className="card__text__container card__body__subtitle">Mass</span>
                    </div>
                    <div className="card__body__text__container">
                      <span className="card__text__container card__body_title">
                        <CustomToolTip title={data?.["template-attribute"]?.["battery-capacity"]}>
                          {data?.["template-attribute"]?.["battery-capacity"]} W
                        </CustomToolTip>
                      </span>
                      <span className="card__text__container card__body__subtitle">Power</span>
                    </div>
                    <div className="card__body__text__container">
                      <span className="card__text__container card__body_title">
                        <CustomToolTip title={data?.["template-attribute"]?.["ADCS"]}>
                          {data?.["template-attribute"]?.["ADCS"]}
                        </CustomToolTip>
                      </span>
                      <span className="card__text__container card__body__subtitle">ADCS</span>
                    </div>
                    <div className="card__body__text__container">
                      <span className="card__text__container card__body_title">
                        <CustomToolTip title={data?.["template-attribute"]?.["NumSolarPanel"]}>
                          {data?.["template-attribute"]?.["NumSolarPanel"]}
                        </CustomToolTip>
                      </span>
                      <span className="card__text__container card__body__subtitle">Solar Panels</span>
                    </div>
                    <div className="card__body__text__container">
                      <span className="card__text__container card__body_title">
                        <CustomToolTip title={data?.["template-attribute"]?.["propulsion"]}>
                          {data?.["template-attribute"]?.["propulsion"]}
                        </CustomToolTip>
                      </span>
                      <span className="card__text__container card__body__subtitle">Propulsion</span>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>

        </div>
      </div>
    </Fragment>

  );
};

export default Bus;
